import { useMutationHook, useQueryHook } from "@/hooks"
import { createResendInvitation, deleteInvitation, readTeamInvitations } from "@/app/api/invitation"
import { Invitation } from "@/types/invitation"

export const useTeamInvitationsQuery = (role: string) => {
  return useQueryHook({
    queryKey: ["readTeamInvitations", role],
    queryFn: async () => {
      const { response, success, error } = await readTeamInvitations(role)
      let result: Invitation[] = []
      if (response) {
        result = response.sort((a, b) => {
          return new Date(b.dateCreated).valueOf() - new Date(a.dateCreated).valueOf()
        })
      }

      return { response: result, success, error }
    },
  })
}

export const useCreateResendInvitationMutation = () => {
  return useMutationHook(createResendInvitation)
}

export const useDeleteInvitationMutation = () => {
  return useMutationHook(deleteInvitation)
}
